import React from "react";
import { Alert } from "antd";

interface ExpiredAlertProps {
  totalHasExpiredCount?: number;

  totalWillExpiredCount?: number;
}

const ExpiredAlert: React.FC<ExpiredAlertProps> = function (props) {
  const { totalHasExpiredCount, totalWillExpiredCount } = props;

  if (totalHasExpiredCount > 0 || totalWillExpiredCount > 0) {
    const message: React.ReactNode[] = [];

    if (totalHasExpiredCount) {
      message.push(
        <span key={totalHasExpiredCount}>
          <span className="text-error">{totalHasExpiredCount}</span>
          个账号已过期
        </span>
      );
    }

    if (totalWillExpiredCount) {
      message.push(
        <span key={totalHasExpiredCount}>
          {message.length ? "，" : ""}
          <span className="text-error">{totalWillExpiredCount}</span>
          个账号即将过期
        </span>
      );
    }

    return <Alert className="mb10" message={<span>{message}</span>} type="info" showIcon />;
  }

  return null;
};

export default React.memo(ExpiredAlert);
